// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__uJKIH","addWidgetButton":"Header_addWidgetButton__5-zmy","dashboardTabs":"Header_dashboardTabs__5SfoQ","active":"Header_active__34fA9"};